import { Component, Input } from '@angular/core';

@Component({
  selector: 'rx-applications-page-section',
  templateUrl: './page-section.component.html',
  styleUrls: ['./page-section.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'flex-column px-3 py-3 mb-4' },
})
export class PageSectionComponent {
  @Input()
  title = 'Title';
}
